'use strict';

var _ = require('../../dependency')._,
  $c = require('../../config'),
  $u = require('../../utilities');

exports.createConfig = createConfig;

function createConfig(ops) {

    var config = {
        chartId: ops.chartId,
        chartType: 'TREND',
        dataSeries: ops.dataSeries,
        fieldNames: ops.fieldNames,
        filters: [$c.filters.DURATION],
        dataConfig: ops.dataConfig,
        dataSeriesFields: null,
        modelFieldKeys: $u.charts.generateFieldKeysArray(ops.dataConfig),
        chartTemplate: ops.chartTemplate,
        i18n: $c.graphs.CHART_METADATA[ops.chartId]
    };

    config.tasks = createTasksList(
      ops,
      config.dataSeriesFields,
      config.modelFieldKeys
    );

    return config;
}

function createTasksList(ops, dataSeriesFields, modelFieldKeys) {
    var modifyResponseTask = {
        config: {
            dataSeries: ops.dataSeries
        }
    };

    if (ops.modifyResponse) {
        modifyResponseTask.plugin = ops.modifyResponse;
    } else {
        modifyResponseTask.name = 'trendModifyResponse';
    }

    return _.compact([
        'durationFilter',
        'druidQueryGenerator',
        'druidQueryValidator',
        'fetchChartData',
        'druidResponseParser',
        ops.averageTask ? 'averageOverInterval' : null,
        'transformResponseToObject',
        modifyResponseTask,
        {
            name: 'updateChartModelData',
            config: {
                dataSeriesFields: dataSeriesFields,
                modelFieldKeys: modelFieldKeys
            }
        }
    ])
}